export class AtividadeOptions {
    canEdit: boolean;
    canDelete: boolean;
    canOpenCliente: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
                this.canDelete ||
                this.canOpenCliente;
    }

    /** Retorna a quantidade de opções disponíveis */
    getCountOptions(): number {
        let count = 0;

        // Editar
        count += this.canEdit ? 1 : 0;
        // Excluir
        count += this.canDelete ? 1 : 0;
        // Abrir cliente
        count += this.canOpenCliente ? 1 : 0;

        return count;
    }
}
